import { z } from 'zod';

import { isoDatetimeToDate } from './dates';
import { fixture } from './fixtures';

export const BizyEverboardingStatus = z.enum(['not_started', 'in_progress', 'completed', 'dismissed']);

export type BizyEverboardingStatus = z.infer<typeof BizyEverboardingStatus>;

export const BizyEverboarding = z.object({
	status: BizyEverboardingStatus,
	createdAt: isoDatetimeToDate.nullable(),
	completedAt: isoDatetimeToDate.nullable(),
	dismissedAt: isoDatetimeToDate.nullable(),
});

export type BizyEverboarding = z.infer<typeof BizyEverboarding>;

export const bizyEverboardingFixture = (overrides: Partial<BizyEverboarding> = {}): BizyEverboarding => ({
	status: 'completed',
	createdAt: fixture.pastDate(14),
	completedAt: fixture.pastDate(7),
	dismissedAt: null,
	...overrides,
});
